export default __webpack_public_path__ + "static/media/img-1.b809f24c.png";